import { EventTypes } from './events'
import type { Callback, EventType, StrippedEvent, SubscriptionCount } from './types'

const store: Map<EventType, Callback[]> = new Map()
const callbacksStore: Map<Callback, EventType[]> = new Map()

export function subscribe(types: EventType | EventType[], callback: Callback): void {
  types = Array.isArray(types) ? types : [types]
  types.forEach((eventType) => {
    const callbacks = store.get(eventType)

    if (callbacks) callbacks.push(callback)
    else store.set(eventType, [callback])

    const eventTypes = callbacksStore.get(callback)

    if (eventTypes) eventTypes.push(eventType)
    else callbacksStore.set(callback, [eventType])
  })
}

export function dispatch(event: StrippedEvent): void {
  const callbacks = store.get(event.type)

  if (!callbacks) return

  event = { ...event, data: event.data || {} }
  callbacks.forEach((callback: any) => callback(event))
}

export function unsubscribe(callback: Callback, type?: EventType): SubscriptionCount {
  if (type) return unsubscribeByType(callback, type)

  return unsubscribeAll(callback)
}

function unsubscribeByType(callback: Callback, eventType: EventType): SubscriptionCount {
  const callbacks = store.get(eventType)

  if (!callbacks) return 0

  const filtered = callbacks.filter((fn) => fn !== callback)
  store.set(eventType, filtered)

  return callbacks.length - filtered.length
}

function unsubscribeAll(callback: Callback): SubscriptionCount {
  const eventTypes = callbacksStore.get(callback)

  if (!eventTypes) return 0

  const count = eventTypes.length
  eventTypes.forEach((eventType: EventType) => {
    unsubscribeByType(callback, eventType)
  })
  callbacksStore.delete(callback)

  return count
}

export { EventTypes }

export type { EventType, StrippedEvent, Callback, SubscriptionCount }
